<template>
  <div class="container">
  <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>
  <div v-else class="autocomplete">
    <input 
      class="form-control2 px-3"
      type="text" 
      v-model="inputValue" 
      @input="onInput" 
      @keydown="onKeyDown"
      placeholder="Search for products"/>
    <div v-if="filteredSuggestions.length" class="autocomplete-items">
      <div 
        v-for="(suggestion, index) in filteredSuggestions" 
        :key="index" 
        :class="['suggestion-item', index === currentIndex ? 'active' : '']"
        @click="selectSuggestion(suggestion)">
        {{ suggestion }}
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inputValue: null,
      suggestions: [],
      currentIndex: -1,
      filteredSuggestions: [],
      loading: false,
    };
  },

  created() {
    this.getSuggestions();
  },

  methods: {

    getSuggestions() {

      this.loading = true;

      axios
        .get('/suggestions')
        .then((response) => {
          this.suggestions = response.data;
          this.loading = false;
        });
    },

    onInput() {
      const query = this.inputValue.toLowerCase();
      this.filteredSuggestions = this.suggestions.filter(
        suggestion => suggestion.toLowerCase().startsWith(query)
      );
      this.currentIndex = -1; // Reset the selection index when typing
    },
    onKeyDown(event) {
      const suggestionsLength = this.filteredSuggestions.length;
      
      if (event.key === 'ArrowDown') {
        // Prevent the default action to avoid cursor movement
        event.preventDefault();

        if (this.currentIndex < suggestionsLength - 1) {
          this.currentIndex++;
        } else {
          this.currentIndex = 0; // Loop back to the top
        }

        this.setInputToSuggestion(this.currentIndex);
      } 
      else if (event.key === 'ArrowUp') {
        // Prevent the default action to avoid cursor movement
        event.preventDefault();

        if (this.currentIndex > 0) {
          this.currentIndex--;
        } else {
          this.currentIndex = suggestionsLength - 1; // Loop to the bottom
        }

        this.setInputToSuggestion(this.currentIndex);
      } 
      else if (event.key === 'Enter' && this.currentIndex !== -1) {
        // When Enter is pressed and a suggestion is selected
        event.preventDefault();
        this.selectSuggestion(this.filteredSuggestions[this.currentIndex]);
      }
    },
    setInputToSuggestion(index) {
      // Set the input field to the selected suggestion
      const selectedSuggestion = this.filteredSuggestions[index];

      if (selectedSuggestion) {
        this.inputValue = selectedSuggestion;

        // Ensure the cursor moves to the end of the input field
        this.$nextTick(() => {
          const input = this.$el.querySelector("input");
          if (input) {
            input.focus();
            const length = input.value.length;
            input.setSelectionRange(length, length);
          }
        });
      }
    },
    selectSuggestion(suggestion) {
      // Set the selected suggestion in the input field
      this.inputValue = suggestion;
      this.filteredSuggestions = []; // Hide suggestions
    }
  }
};
</script>

<style scoped>
/* Ensure the autocomplete container is correctly positioned */
.autocomplete {
  position: relative;
}

/* Suggestions dropdown with a higher z-index and defined position */
.autocomplete-items {
  /* position: absolute; */
  z-index: 1050; /* Ensure it's above other elements */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

/* Individual suggestion items */
.suggestion-item {
  padding: 5px 15px;
  cursor: pointer;
}

/* Highlight active suggestion */
.suggestion-item.active {
  background-color: #e9e9e9;
  color: black;
}

/* Hover effect */
.suggestion-item:hover {
  background-color: #e9e9e9;
  color: black;
}

/* Debugging */
/* .suggestion-item {
  border-bottom: 1px solid #ddd;
} */

/* Ensure body overflow does not affect absolute positioning */
body {
  overflow-x: visible;
}
</style>
